module.exports = __webpack_public_path__ + "static/media/shared.52aa22fc.svg";